module.exports = "<div ng-show=\"$ctrl.canChange\" class=\"resize-handle\"><i class=\"icon-corner-handle\"></i></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/dashboard/resize-handler/resize-handler.component.html
// module id = 498
// module chunks = 0